/**
 * @description 带默认图回退的图片组件
 * @author wayou
 */

import React, { Component } from 'react';
import { PreImg } from 'common/src/components';
import './UMUImg.scss';
import { base64Image } from './util';

interface IUmuImgProps {
    enablePreview?: boolean; // 是否支持微信预览
    clsName?: string; // 自定义类名
    src: string; // 图片地址
    loadingHolder?: string; // 自定义加载中图片
    fallbackSrc: string; // 自定义默认图
    onError?: () => void; // 自定义错误处理
    onLoad?: () => void; // 自定义加载处理
    alt?: string; // 图片说明
}

interface IUmuImgState {
    src: string;
    defaultImgCls: string;
}

class UMUImg extends Component<IUmuImgProps, IUmuImgState> {
    public static defaultProps: Partial<IUmuImgProps> = {
        clsName: '',
        src: '',
        loadingHolder: base64Image.IMG_LOADING,
        fallbackSrc: base64Image.IMG_LOAD_ERROR,
        alt: '',
    };
    constructor(props: IUmuImgProps) {
        super(props);
        console.warn(`deprecated, use emg instead`);

        const defaultSrc = props.loadingHolder || base64Image.IMG_LOAD_ERROR;

        this.state = {
            src: defaultSrc,
            defaultImgCls: 'umu-img-default',
        };

        this.loadImg = this.loadImg.bind(this);
        this.preview = this.preview.bind(this);
    }

    public componentDidMount() {
        this.loadImg();
    }

    public loadImg() {
        const props = this.props;
        const img = new Image();
        img.onload = () => {
            this.setState({
                src: this.props.src,
                defaultImgCls: '',
            });
            // 如果外部有自定义的 onload则调用一下
            if (props.onLoad) {
                props.onLoad();
            }
        };
        img.onerror = () => {
            this.setState({
                src: this.props.fallbackSrc,
                defaultImgCls: 'umu-img-error',
            });
            // 如果外部有自定义的 onError则调用一下
            if (props.onError) {
                props.onError();
            }
        };
        img.src = this.props.src;
    }

    public UNSAFE_componentWillReceiveProps(newProps: IUmuImgProps) {
        if (newProps.src !== this.props.src) {
            this.setState({
                src: newProps.src,
            });
        }
    }

    public preview() {
        if (!this.props.enablePreview || typeof wx === 'undefined') {
            return;
        }
        // 如果图片地址带参数，去掉参数使用原图
        const src = this.state.src.replace(/@.*?$/g, '');
        wx.previewImage({
            current: src,
            urls: [src],
        });
    }

    public render() {
        const props = this.props;
        return (
            <PreImg>
                <img
                    onClick={this.preview}
                    className={'umu-img ' + this.state.defaultImgCls + ' ' + props.clsName}
                    src={this.state.src}
                    alt={props.alt}
                />
            </PreImg>
        );
    }
}

export default UMUImg;
